var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded"},[_c('div',{staticClass:"avatar-popup",class:{ visible: _vm.showPopup }},[_vm._t("popup")],2),_c('div',{staticClass:"avatar",style:(_vm.avatarStyle),on:{"click":_vm.togglePopup}})])}
var staticRenderFns = []

export { render, staticRenderFns }